import { Body, BodyProps, Box, BoxProps } from '@hover/blueprint';
import React, { FC, ReactChild } from 'react';
import StyledFloatingLabelWrapper from './StyledFloatingLabelWrapper';

interface Props extends BoxProps {
  options: string[];
  label: string | ReactChild;
  valueProps?: BodyProps;
  defaultValue?: string;
  setValue: Function;
}

const generateKey = (pre: string) => `${pre}_${new Date().getTime()}`;

const FloatingLabelSelector: FC<Props> = ({
  options,
  label,
  valueProps,
  defaultValue,
  setValue,
  ...rest
}) => (
  <StyledFloatingLabelWrapper width="100%">
    <Box className="form-floating" {...rest}>
      <Box
        as="select"
        className="form-select"
        id="floatingSelect"
        aria-label="Floating label select example"
        defaultValue={defaultValue}
        onChange={e => {
          setValue((e.target as HTMLTextAreaElement).value);
        }}
        {...valueProps}
      >
        {options.map(option => (
          <Body as="option" key={generateKey(option)} value={option}>
            {option}
          </Body>
        ))}
      </Box>
      <label htmlFor="floatingSelect">{label}</label>
    </Box>
  </StyledFloatingLabelWrapper>
);

FloatingLabelSelector.defaultProps = {
  valueProps: {},
  defaultValue: undefined,
};

export default FloatingLabelSelector;
